var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFandomIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1792.9 2493.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1773.9,1298.1c-12.5-30.2-30.8-57.7-53.9-80.8h0L516.3,13c-12.7-12.7-31.8-16.5-48.5-9.6-16.6,6.9-27.4,23.1-27.4,41.1v1012.6L75.8,692.5c-12.7-12.7-31.8-16.5-48.4-9.6C10.8,689.8-.1,706,0,724v1045.7c-.1,66,26.2,129.3,72.8,175.9l474.4,475c46.6,46.7,109.9,72.9,175.9,73h347c66,0,129.2-26.3,175.8-72.9l474.3-475c46.6-46.7,72.8-110,72.7-175.9v-376.4c0-32.7-6.5-65-19-95.3h0ZM1352.8,1657.8c0,19.7-7.8,38.7-21.7,52.7l-382.4,384.3c-21.3,21.5-53.6,28-81.5,16.3-9.1-3.8-17.3-9.3-24.3-16.3l-381.1-384.3c-13.9-13.9-21.8-32.8-21.8-52.5v-146.2c0-19.8,7.9-38.7,21.9-52.7l137.2-137.3c29-29.2,76.1-29.3,105.3-.3.1.1.2.2.3.3l191.9,192.1,191.6-192.2c14-14,33-21.9,52.8-21.9s38.8,7.9,52.8,21.9l137.2,137.3c14,14,21.9,32.9,21.9,52.7v146.1h-.1Z",
    fill: "#FA5A5A",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFandomIconColour);
export default __webpack_public_path__ + "static/media/fandomIconColour.1bfaa5c544b62c044e54099b6ff20540.svg";
export { ForwardRef as ReactComponent };